import React, { FC } from 'react';
import { Card, CardContent, CardHeader, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { openExternalLink } from '../../RefundV2.helpers';

type RefundV2CustomerInfoCardProps = {
    customerId: any;
    documentHeaderOfInvoice: any;
    otherLink: string;
};

export const RefundV2CustomerInfoCard: FC<RefundV2CustomerInfoCardProps> = ({
    customerId,
    documentHeaderOfInvoice,
    otherLink,
}) => {
    const { t } = useTranslation();

    return (
        <Card style={{ height: '30rem' }}>
            <CardHeader
                title={
                    <Typography noWrap gutterBottom variant="h6" component="h4">
                        <b>{t('refund.customerInfo')}</b>
                    </Typography>
                }
            />
            <Divider />
            <CardContent>
                {customerId && (
                    <p>
                        <b>{t('refund.customerId')}: </b>
                        <label
                            className="linktxt"
                            onClick={() => {
                                openExternalLink(
                                    `${otherLink}/customerManagement?ActiveTab=OrderInformation&customerId=${customerId}`
                                );
                            }}
                        >
                            {customerId}
                        </label>
                    </p>
                )}
                {documentHeaderOfInvoice && (
                    <p>
                        <b>{t('refund.customer')}</b>
                        {documentHeaderOfInvoice.customerFirstName} {documentHeaderOfInvoice.customerLastName}
                    </p>
                )}
                <br />
                <br />
            </CardContent>
        </Card>
    );
};
